import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import ContentBuilder from '~/components/Layout/Builders/ContentBuilder';
import { ArticleContext } from '~/contexts/ArticleContext';
import { AppDataContext } from '~/contexts/AppDataContext';
import { maybeGetSlide } from '~/utilities/maybeGetSlide';
import type { ArticleInterface } from '~/types/AppData/PageContent/ArticleInterface';
import { maybeMoveVideoPlayer } from '~/utilities/maybeMoveVideoPlayer';
import { useIsOdesaTemplate } from '~/utilities/useIsOdesaTemplate';

const contentClasses = cva('article-content', {
  variants: {
    isOdesa: {
      true: '[&_p]:leading-[30px] [&_p]:md:leading-[28px] [&_li]:leading-[30px] [&_li]:md:leading-[28px]',
      false: '',
    },
  },
});
export default component$((): JSX.Element => {
  const { payloadToSSR, appState } = useContext(AppDataContext);
  const article = useContext(ArticleContext);
  const { experiments, edition, isMobileViewer } = payloadToSSR;
  const isOdesa = useIsOdesaTemplate();

  if (!article) return <></>;

  const slideshow = payloadToSSR.pageContent.slideshow ?? article.slideshow;

  return (
    <div class={contentClasses({ isOdesa })}>
      <ContentBuilder
        items={maybeMoveVideoPlayer(
          maybeGetSlide(
            article as ArticleInterface,
            slideshow,
            appState.currentSlide,
            experiments
          ),
          edition,
          !!isMobileViewer
        )}
      />
    </div>
  );
});
